import * as React from 'react';
import * as RadixDialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cn } from '../../lib/cn';

export const Dialog = RadixDialog.Root;
export const DialogTrigger = RadixDialog.Trigger;

export function DialogContent({
  className,
  children,
  title,
  description,
  ...props
}: React.ComponentPropsWithoutRef<typeof RadixDialog.Content> & {
  title: string;
  description?: string;
}) {
  return (
    <RadixDialog.Portal>
      <RadixDialog.Overlay className="dialog-overlay" />
      <RadixDialog.Content className={cn('dialog-content', className)} {...props}>
        <div className="dialog-header">
          <RadixDialog.Title className="dialog-title">{title}</RadixDialog.Title>
          <RadixDialog.Close className="dialog-close" aria-label="Sluiten">
            <X size={18} />
          </RadixDialog.Close>
        </div>
        {description ? (
          <RadixDialog.Description className="dialog-description">
            {description}
          </RadixDialog.Description>
        ) : null}
        <div className="dialog-body">{children}</div>
      </RadixDialog.Content>
    </RadixDialog.Portal>
  );
}

export const DialogFooter = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('dialog-footer', className)} {...props} />
);
